(function () {
  if (window.variantMediaGroups) {
    window.variantMediaGroups.init();
    return;
  }

  function readData(section) {
    var script = document.querySelector('script[data-variant-media-groups][data-section="' + section + '"]');
    if (!script) return null;
    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
    var featured = data.featured.map(String);
    var groups = {};
    var current = null;
    data.media.map(String).forEach(function (id) {
      if (featured.indexOf(id) !== -1) {
        current = id;
        groups[id] = [];
      } else if (current) {
        groups[current].push(id);
      }
    });
    return { groups: groups, initial: data.initial ? String(data.initial) : null };
  }

  /* Moves the matched elements, in order, to sit right after the anchor element */
  function moveAfter(container, anchorSelector, selectors) {
    var anchor = container.querySelector(anchorSelector);
    if (!anchor) return;
    selectors.forEach(function (selector) {
      var element = container.querySelector(selector);
      if (!element || element === anchor || element.parentElement !== anchor.parentElement) return;
      anchor.after(element);
      anchor = element;
    });
  }

  function apply(section, featuredId) {
    var data = readData(section);
    featuredId = featuredId ? String(featuredId) : null;
    if (!data || !featuredId || !data.groups[featuredId]) return;

    var extras = data.groups[featuredId];
    var galleries = document.querySelectorAll('[id^="MediaGallery-' + section + '"]');

    galleries.forEach(function (gallery) {
      moveAfter(
        gallery,
        '[data-media-id="' + section + '-' + featuredId + '"]',
        extras.map(function (id) {
          return '[data-media-id="' + section + '-' + id + '"]';
        })
      );
      moveAfter(
        gallery,
        '[data-target="' + section + '-' + featuredId + '"]',
        extras.map(function (id) {
          return '[data-target="' + section + '-' + id + '"]';
        })
      );
    });

    var modal = document.getElementById('ProductModal-' + section);
    if (modal) {
      moveAfter(
        modal,
        '[data-media-id="' + featuredId + '"]',
        extras.map(function (id) {
          return '[data-media-id="' + id + '"]';
        })
      );
    }

    var rules = [];
    Object.keys(data.groups).forEach(function (key) {
      if (key === featuredId) return;
      data.groups[key].forEach(function (id) {
        rules.push(
          '[data-media-id="' + section + '-' + id + '"],' +
            '[data-target="' + section + '-' + id + '"],' +
            '#ProductModal-' + section + ' [data-media-id="' + id + '"]' +
            '{display:none!important}'
        );
      });
    });
    var style = document.getElementById('VariantMediaGroupsStyle-' + section);
    if (style) style.textContent = rules.join('');

    galleries.forEach(function (gallery) {
      gallery.querySelectorAll('slider-component').forEach(function (slider) {
        if (slider.slider && typeof slider.resetPages === 'function') slider.resetPages();
      });
    });
  }

  function init() {
    document.querySelectorAll('script[data-variant-media-groups]').forEach(function (script) {
      var section = script.dataset.section;
      var picker = document.querySelector(
        'variant-selects[data-section="' + section + '"], variant-radios[data-section="' + section + '"]'
      );
      var variant = picker && picker.currentVariant;
      var featuredId = variant && variant.featured_media ? variant.featured_media.id : null;
      if (!featuredId) {
        var data = readData(section);
        featuredId = data && data.initial;
      }
      apply(section, featuredId);
    });
  }

  window.variantMediaGroups = { init: init, apply: apply };

  document.addEventListener('change', function (event) {
    var picker = event.target.closest ? event.target.closest('variant-selects, variant-radios') : null;
    if (!picker) return;
    var variant = picker.currentVariant;
    if (!variant || !variant.featured_media) return;
    apply(picker.dataset.section, variant.featured_media.id);
  });

  document.addEventListener('shopify:section:load', init);

  init();
})();
